import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export default class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Chart rendering error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card variant="outlined">
          <CardContent>
            <Typography variant="subtitle2">Chart error</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>{this.state.error?.message || 'An error occurred rendering this chart.'}</Typography>
          </CardContent>
        </Card>
      );
    }

    return this.props.children;
  }
}

ChartErrorBoundary.propTypes = {
  children: PropTypes.node
};
